var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"flex":""}},[_vm._v(" Please wait a moment, app is loading ")])
}
var staticRenderFns = []

export { render, staticRenderFns }